import { render, staticRenderFns } from "./CompanySideBar.vue?vue&type=template&id=2e3cf540&"
import script from "./CompanySideBar.vue?vue&type=script&lang=js&"
export * from "./CompanySideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports